module.exports = "/images/icon_32_location.png?0ef3f865bda578d5c7b0e4abf448f9eb";